import React from 'react';
import PropTypes from 'prop-types';
import { StyledScrollAvatar } from './style';
import { SelectAvatarOW } from '../AvatarEdition/style';

const ScrollAvatar = ({ className, getAvatar }) => (
  <StyledScrollAvatar className={className}>
    <SelectAvatarOW getAvatar={avatar => getAvatar(avatar)} />
  </StyledScrollAvatar>
);

ScrollAvatar.propTypes = {
  className: PropTypes.string,
  getAvatar: PropTypes.func
};

export default ScrollAvatar;
